import Isotope from 'isotope-layout';

const isotopeInit = () => {
  if (document.querySelector('.grid-iso') !== null) {
    const buttonSelector = document.querySelector('.button-group');

    // filter functions
    const filterFns = {};

    const iso = new Isotope('.grid-iso .wp-block-columns', {
      itemSelector: '.wp-block-column',
    });

    buttonSelector.addEventListener('click', function (event) {
      let filterValue = event.target.getAttribute('data-filter');
      // use matching filter function
      filterValue = filterFns[filterValue] || filterValue;
      iso.arrange({ filter: filterValue });
    });
  }

  function debounce(fn, threshold) {
    let timeout;
    threshold = threshold || 100;
    return function debounced() {
      clearTimeout(timeout);
      let args = arguments;
      let _this = this;
      function delayed() {
        fn.apply(_this, args);
      }
      timeout = setTimeout(delayed, threshold);
    };
  }

  if (document.querySelector('.grid-iso__custom') !== null) {
    const buttonSelector = document.querySelector('.button-group');
    const quickSearch = document.querySelector('.quicksearch');
    var qsRegex, buttonFilter, filterValue;

    // filter functions
    const filterFns = {};

    const iso = new Isotope('.grid-iso__custom >.wp-block-columns', {
      itemSelector: '.grid-iso__custom >.wp-block-columns >.wp-block-column',
      layoutMode: 'fitRows',
      filter: function (itemElem) {
        //return qsRegex ? itemElem.textContent.match(qsRegex) : true;

        let searchResult = qsRegex ? itemElem.textContent.match(qsRegex) : true;
        let buttonResult = buttonFilter ? itemElem === buttonFilter : true;
        return searchResult && buttonResult;
      },
    });

    quickSearch.addEventListener(
      'keyup',
      debounce(function () {
        qsRegex = new RegExp(quickSearch.value, 'gi');
        iso.arrange();
      }, 200)
    );

    buttonSelector.addEventListener('click', function (event) {
      filterValue = event.target.getAttribute('data-filter');
      let filterBtn = document.querySelector('[data-filter="' + filterValue + '"]');

      event.target.parentElement.querySelectorAll('.active').forEach((e) => e.classList.remove('active'));
      filterBtn.classList.add('active');

      // use matching filter function
      filterValue = filterFns[filterValue] || filterValue;
      iso.arrange({ filter: filterValue });
    });
  }
};

export { isotopeInit };
